import script from "./ProjectGoals.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectGoals.vue?vue&type=script&setup=true&lang=js"

import "./ProjectGoals.vue?vue&type=style&index=0&id=26e75e16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e75e16"]])

export default __exports__